import { useState, useCallback } from 'react';
import { ChangeEvent } from 'react';

export interface CheckboxState {
  [key: string]: boolean;
}
export type SetCheckboxState = (value: CheckboxState) => void;
export type ChangeCheckboxState = (event: ChangeEvent<Element>, isChecked: boolean) => void;

export const useCheckboxState = (initValue: CheckboxState) => {
  const [value, setValue] = useState<CheckboxState>(() => (initValue || {}));

  const onChangeValue = useCallback((event: any, isChecked: boolean) => {
    const key = event.target.value;
    setValue((state) => {
      const { [key]: keyValue, ...partState } = state;
      return { ...partState, ...isChecked && { [key]: true } };
    });
  }, [setValue]);

  return [value, onChangeValue, setValue] as const;
};
